import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Primary } from '../../../assets/Colors';
import { getAllUsers } from '../../../api/User';
import { getAllBooks } from '../../../api/Book';
import { GetAllCoaches } from '../../../api/AdminCoachPanel/coachApis';
import { getReports } from '../../../api/FeedBacks';
import SideBar from '../../../components/SideBar';
import { Components } from '../../../assets/Dimensions';
import { setSelectedItem } from '../../../redux/actions/sidebarAction';
import { getGroupedMenuItemsForRole, Roles } from '../../../assets/menuConfig';

const AdminDashboard = ({ setSelectedItem }) => {
    const history = useHistory();
    const User = JSON.parse(localStorage.getItem('user'));
    
    const [stats, setStats] = useState({
        totalUsers: 0,
        totalBooks: 0,
        totalCoaches: 0,
        totalFeedbacks: 0
    });

    const [search, setSearch] = useState('');
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        setSelectedItem('');
        const fetchStats = async () => {
             if (User && User.Token) {
                try {
                    // Fetch Users Count
                    // Matching MembersPage.js pattern
                    const usersRes = await getAllUsers({
    "PageSize": 6,
    "PageNumber": 0,
    "SearchValue": "",
    "OrderColumn": "",
    "OrderBy": 1
}, User.Token);
                    
                    // Fetch Books Count
                    // Matching BooksPage.js pattern
                    const booksRes = await getAllBooks({
    "PageSize": 6,
    "PageNumber": 0,
    "SearchValue": "",
    "OrderColumn": "",
    "OrderBy": 1
}, User.Token);

                    // Fetch Coaches Count
                    // Coaches.js uses 'jwtP' from sessionStorage (Admin Token)
                    const jwtP = sessionStorage.getItem("jwtP");
                    const coachesToken = jwtP || User.Token;
                    const coachesRes = await GetAllCoaches(coachesToken, true);

                    // Fetch Feedbacks Count
                    // params taken from FeedBacksPage.js defaults
                    const reportsParams = {
                      MonthCount: 3,
                      StatusType: 2, // All
                      OrderBy: 0
                    };
                    const feedbacksRes = await getReports(reportsParams, User.Token);

                    setStats({
                        totalUsers: usersRes && usersRes.data && usersRes.data.Users ? (usersRes.data.RowCount || 0) : 0,
                        totalBooks: booksRes && booksRes.data && booksRes.data.Books ? (booksRes.data.RowCount || 0) : 0,
                        totalCoaches: coachesRes && coachesRes.data && Array.isArray(coachesRes.data.ResponseData) ? coachesRes.data.ResponseData.length : 0,
                        totalFeedbacks: feedbacksRes && feedbacksRes.data && Array.isArray(feedbacksRes.data) ? feedbacksRes.data.length : 0
                    });

                } catch (e) {
                     console.error("Failed to fetch admin stats", e);
                }
             }
        };

        fetchStats();
    }, []);



    // Pages come from the shared menu config (assets/menuConfig.js). Each section is
    // a tab; the search box looks across every section at once. Same config drives the sidebar.
    const menuSections = getGroupedMenuItemsForRole(Roles.Administrators);
    const query = search.trim().toLocaleLowerCase('tr');
    const searchResults = query
        ? menuSections
              .reduce((acc, section) => acc.concat(section.items), [])
              .filter((item) => item.title.toLocaleLowerCase('tr').includes(query))
        : [];
    // Tab 0 is the "Tümü" (All) tab; group tabs start at index 1.
    const activeSection = activeTab > 0 && menuSections.length > 0
        ? menuSections[Math.min(activeTab - 1, menuSections.length - 1)]
        : null;

    const renderCard = (item) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={item.path}>
            <Card
                style={{ cursor: 'pointer', height: '100%' }}
                onClick={() => history.push(item.path)}
            >
                <CardContent style={{ textAlign: 'center' }}>
                    <img src={item.icon} alt={item.title} style={{ width: 50, height: 50, marginBottom: 10 }} />
                    <Typography variant="h6" component="h2">
                        {item.title}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );

    const statCards = [
        { label: 'Total Users', value: stats.totalUsers },
        { label: 'Total Books', value: stats.totalBooks },
        { label: 'Total Coaches', value: stats.totalCoaches },
        { label: 'Feedbacks', value: stats.totalFeedbacks },
    ];

    return (
        <div>
            <SideBar />
            <div style={{ 
                padding: 20, 
                marginLeft: Components.SideBarWidth + 15, // Adjusted for Sidebar
                marginRight: 30,
                paddingTop: 20
            }}>
            <Typography variant="h4" style={{ color: Primary.TextColor, marginBottom: 20 }}>
                Admin Dashboard
            </Typography>

            {/* Statistics Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                System Overview
            </Typography>
            <Grid container spacing={3} style={{ marginBottom: 30 }}>
                {statCards.map((stat, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                         <Card style={{ height: '100%', backgroundColor: Primary.Background }}>
                            <CardContent style={{ textAlign: 'center' }}>
                                <Typography variant="h3" style={{ color: Primary.TopBar }}>
                                    {stat.value}
                                </Typography>
                                <Typography variant="subtitle1" style={{ color: Primary.TextColor }}>
                                    {stat.label}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Menu Section */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
                <Typography variant="h5" style={{ color: Primary.TextColor }}>
                    Management Modules
                </Typography>
                <TextField
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Sayfa ara..."
                    variant="outlined"
                    size="small"
                    style={{ minWidth: 260, backgroundColor: Primary.ContainerBackground }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ color: Primary.TextColor }} />
                            </InputAdornment>
                        )
                    }}
                />
            </div>

            {query ? (
                /* Search mode: matches from every group, flat. */
                searchResults.length > 0 ? (
                    <Grid container spacing={3} style={{ marginTop: 8 }}>
                        {searchResults.map(renderCard)}
                    </Grid>
                ) : (
                    <Typography variant="body1" style={{ color: Primary.TextColor, opacity: 0.7, marginTop: 8 }}>
                        "{search}" için sayfa bulunamadı.
                    </Typography>
                )
            ) : (
                /* Browse mode: one tab per group. */
                <>
                    <Tabs
                        value={Math.min(activeTab, menuSections.length)}
                        onChange={(e, value) => setActiveTab(value)}
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                        style={{ marginBottom: 20, borderBottom: '1px solid rgba(0,0,0,0.12)' }}
                    >
                        <Tab label="Tümü" />
                        {menuSections.map((section) => (
                            <Tab key={section.group} label={section.group} />
                        ))}
                    </Tabs>

                    {activeTab === 0 ? (
                        /* Tümü: every group at once, with section headers. */
                        menuSections.map((section) => (
                            <div key={section.group} style={{ marginBottom: 24 }}>
                                <Typography
                                    variant="subtitle1"
                                    style={{ color: Primary.TextColor, fontWeight: 600, marginBottom: 10, opacity: 0.85 }}
                                >
                                    {section.group}
                                </Typography>
                                <Grid container spacing={3}>
                                    {section.items.map(renderCard)}
                                </Grid>
                            </div>
                        ))
                    ) : (
                        activeSection && (
                            <Grid container spacing={3}>
                                {activeSection.items.map(renderCard)}
                            </Grid>
                        )
                    )}
                </>
            )}
            </div>
        </div>
    );
};



const mapDispatchToProps = (dispatch) => ({
    setSelectedItem: (item) => dispatch(setSelectedItem(item))
});

export default connect(null, mapDispatchToProps)(AdminDashboard);
